<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('wallet')">
      <span
        :class="b('icon', { wallet: true })"
        v-html="displayedIcons.wallet"
      ></span>

      <div v-if="displayedCurrency.fiat" :class="b('wallet-group')">
        <p :class="b('label')">
          {{ displayedFiatAmount }}
        </p>

        <div :class="b('wallet-currency')" v-click-outside="handleFiatHide">
          <button
            :class="[
              b('wallet-currency__toggle', { view }),
              displayedFiatActiveClass,
            ]"
            @click="handleFiatToggle"
          >
            {{ displayedFiatCurrency }}
          </button>

          <div
            :class="
              b('wallet-currency__options', { view, visible: isFiatVisible })
            "
          >
            <button
              :class="
                b('wallet-currency__option', {
                  view,
                  active: option === displayedFiatCurrency,
                })
              "
              v-for="option in displayedFiatCurrensies"
              :key="option"
              @click="handleFiatOption(option)"
            >
              {{ option }}
            </button>
          </div>
        </div>
      </div>

      <div :class="b('divider')">|</div>

      <div v-if="displayedCurrency.crypto" :class="b('wallet-group')">
        <p :class="b('label')">
          {{ displayedCryptoAmount }}
        </p>

        <div :class="b('wallet-currency')" v-click-outside="handleCryptoHide">
          <button
            :class="[
              b('wallet-currency__toggle', { view }),
              displayedCryptoActiveClass,
            ]"
            @click="handleCryptoToggle"
          >
            {{ displayedCryptoCurrency }}
          </button>

          <div
            :class="
              b('wallet-currency__options', { view, visible: isCryptoVisible })
            "
          >
            <button
              :class="
                b('wallet-currency__option', {
                  view,
                  active: option === displayedCryptoCurrency,
                })
              "
              v-for="option in displayedCryptoCurrensies"
              :key="option"
              @click="handleCryptoOption(option)"
            >
              {{ option }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <SharedVerificationBanner :class="b('verification-banner')" />

    <div :class="b('group')">
      <SharedLanguage :class="b('language')" view="light" />

      <div :class="b('profile')">
        <p :class="b('label')">{{ displayedUserInfo.email }}</p>

        <button
          :class="b('profile-logout')"
          :disabled="isLogoutDisabled"
          @click="handleLogout"
        >
          <span :class="b('icon')" v-html="displayedIcons.logout"></span>
        </button>
      </div>
    </div>
  </div>
</template>
